(function () {
  "use strict";

  if (!window.preact || !window.preactHooks) {
    console.error("Preact and preactHooks are required for league modal rendering");
    return;
  }

  const { h, render } = window.preact;
  const { useEffect, useMemo, useState } = window.preactHooks;

  function normalizeRegionValue(value) {
    return String(value || "").trim().replace(/\s+/g, " ").toLowerCase();
  }

  function FrontendLeagueModal(props) {
    const {
      isOpen,
      onClose,
      onSubmit,
      allProfiles = [],
      locationStateOptions = [],
      isGlobalCustomer = false,
    } = props;

    const [open, setOpen] = useState(Boolean(isOpen));
    const [saveStatus, setSaveStatus] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
      setOpen(Boolean(isOpen));
    }, [isOpen]);

    const getStateAbbrev = (value) => {
      const raw = String(value || "").trim();
      if (!raw) return "";
      const normalized = normalizeRegionValue(raw);
      const matched = (locationStateOptions || []).find(
        (option) => normalizeRegionValue(option) === normalized
      );
      return String(matched || raw).trim();
    };

    const getStateDisplayName = (value) => {
      const raw = String(value || "").trim();
      if (!raw) return "";
      const normalized = normalizeRegionValue(raw);
      const matched = (locationStateOptions || []).find(
        (option) => normalizeRegionValue(option) === normalized
      );
      return String(matched || raw).trim();
    };

    const profiles = useMemo(
      () => (Array.isArray(allProfiles) ? allProfiles : []).filter((profile) => profile && profile.id),
      [allProfiles]
    );

    function closeModal() {
      setOpen(false);
      if (typeof onClose === "function") onClose();
    }

    async function submit(payload) {
      if (isSubmitting || /^saving\b/i.test(String(saveStatus || ""))) return;
      setIsSubmitting(true);
      setSaveStatus("Saving...");
      try {
        const response = await fetch("/a/app?app=create-profile-league", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!data?.success) {
          throw new Error(data?.error || "Failed to create league");
        }
        setSaveStatus("League created.");
        if (typeof onSubmit === "function") onSubmit(data);
      } catch (error) {
        setSaveStatus(error?.message || "Failed to create league");
      } finally {
        setIsSubmitting(false);
      }
    }

    if (!open) return null;

    const renderer =
      (typeof window.SharedPreactLeagueModalRenderer === "function" && window.SharedPreactLeagueModalRenderer) ||
      (typeof window.SharedLeagueModalRenderer === "function" && window.SharedLeagueModalRenderer);

    if (renderer) {
      return renderer({
        h,
        initialData: null,
        profiles,
        getStateAbbrev,
        getStateDisplayName,
        isGlobalCustomer,
        onClose: closeModal,
        onSubmit: submit,
        saveStatus,
      });
    }

    return null;
  }

  window.renderFrontendLeagueForm = function renderFrontendLeagueForm(mountNode, options) {
    if (!mountNode) return;
    const props = options || {};
    render(h(FrontendLeagueModal, props), mountNode);
  };
})();
